import Vue from 'vue'
import Router from 'vue-router'

import routes from './routes'
import router from './router'

Vue.use(Router)

const { BASE_URL } = process.env

export default new Router({
  mode: 'history',
  base: BASE_URL,
  routes: [
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Ad Manager',
      },
      name: 'admanager',
      path: '/admanager/:reportName?/:reportId?/:subId?',
      props: router.props,
    },

    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Admin',
      },
      name: 'admin',
      path: '/admin/:reportName?/:reportId?',
      props: router.props,
    },

    {
      alias: ['/account'],
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Settings',
      },
      name: 'settings',
      path: '/settings/:reportName?/:reportId?',
      props: router.props,
    },

    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Reports',
      },
      name: 'reports',
      path: '/reports/:reportName?/:reportId?/:subId?',
      props: router.props,
    },
    {
      // Redirecting, so no component is needed.
      // component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Delivery',
      },
      name: 'delivery',
      path: '/delivery/:reportName?/:reportId?/:subId?',
      props: router.props,
      redirect: (to) => {
        const { reportId, reportName, subId } = to.params
        const reportPaths = ['/reports']

        if (reportName) {
          reportPaths.push(reportName)

          if (reportId) {
            reportPaths.push(reportId)

            if (subId) {
              reportPaths.push(subId)
            }
          }
        }

        return {
          path: reportPaths.join('/'),
        }
      },
    },
    {
      // Redirecting, so no component is needed.
      // component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Programmatic',
      },
      name: 'programmatic',
      path: '/programmatic/:reportName?/:reportPath?/:reportId?/:subId?',
      props: router.props,
      redirect: (to) => {
        const { reportId, reportName, subId } = to.params
        const reportPaths = ['/reports']

        if (reportName) {
          const reportNameMap = {
            adx: 'adx-health',
            network: 'network-health',
            partner: 'adx-and-ob',
          }

          const newReportName = reportNameMap[reportName] || reportName

          reportPaths.push(newReportName)

          if (reportId) {
            reportPaths.push(reportId)

            if (subId) {
              reportPaths.push(subId)
            }
          }
        }

        return {
          path: reportPaths.join('/'),
        }
      },
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Docs',
      },
      name: 'docs',
      path: '/docs/:reportName?/:reportId?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Internal',
      },
      name: 'internal',
      path: '/internal/:reportName?/:reportId?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Custom Reports',
      },
      name: 'custom-reports',
      path: '/custom-reports/:reportName?/:reportId?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Dev',
      },
      name: 'dev',
      path: '/dev/:reportName?',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Sign In',
      },
      name: 'sign-in',
      path: '/sign-in',
      props: router.props,
    },
    {
      // No requiresAuth: this route is intentionally reachable with or
      // without a signed-in session (see Layout.vue's isPrivacyPolicyRoute).
      component: routes.MAIN_CONTENT.component,
      meta: {
        title: 'Privacy Policy',
      },
      name: 'privacy-policy',
      path: '/privacy-policy',
      props: router.props,
    },
    {
      // No requiresAuth: reachable with or without a signed-in session,
      // same as /privacy-policy (see Layout.vue's isTermsOfServiceRoute).
      // The page itself carries a prominent "DRAFT - Pending Legal
      // Review" banner - being publicly reachable doesn't mean it's
      // approved or binding.
      component: routes.MAIN_CONTENT.component,
      meta: {
        title: 'Terms of Service',
      },
      name: 'terms-of-service',
      path: '/terms-of-service',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Reset Password',
      },
      name: 'reset-password',
      path: '/reset-password',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Sign Out',
      },
      name: 'sign-out',
      path: '/sign-out',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Sign Up',
      },
      name: 'sign-up',
      path: '/sign-up',
      props: router.props,
      alias: '/register',
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Forgot Password',
      },
      name: 'forgot-password',
      path: '/forgot-password',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Index',
      },
      name: 'index',
      path: '/index.html',
      props: router.props,
    },
    {
      component: routes.MAIN_CONTENT.component,
      meta: {
        requiresAuth: true,
        title: 'Dashboard',
      },
      name: 'dashboard',
      path: '/',
      props: router.props,
    },

    // {
    //   component: routes.REDIRECT_PAGE.component,
    //   meta: {
    //     requiresAuth: false,
    //     title: 'Redirect Example',
    //   },
    //   path: '/redirect-example',
    //   alias: '/redirect',
    //   redirect() {
    //     window.location.replace('https://google.com')
    //   },
    // },
  ],
})
